import React, { useEffect, useRef, useState } from 'react';
import { SERVER_URL } from '../utils/constants';
import {
    View,
    StyleSheet,
    Dimensions,
    ScrollView,
    TextInput,
} from 'react-native';
import { Header } from '../component/Header';
import User from '../object/User';
import { HEADER_BONUS_HEIGHT } from '../utils/screen';
import { getColor } from '../utils/theme';
import xml2js from 'xml2js'; // Import xml2js
import Stand from '../object/Stand';
import { get } from '../utils/http';
import { HTTPUtils } from 'mp-ts-http';
import useJTOState from '../utils/jto/useJTOState';
import { applyResult } from '../utils/applyResult';
import { useTranslation } from 'react-i18next';
import GeSpinner from '../component/GeSpinner';
import JTOList from '../utils/jto/JTOList';
declare const Panzoom: any;

const { width, height } = Dimensions.get('window');

const boxList = {} as any;

const HALL_DICT = {
    '2': 'HALL 2',
    '1': 'HALL 1',
    entree: 'ESPACE ENTREE',
    air_libre: 'AIR LIBRE',
};

export const MapPage = (props: any) => {
    const [svgContent, setSvgContent] = useState('');
    const [parsedSvg, setParsedSvg] = useState('');

    const [loading, setLoading] = useState(true);

    const event = useJTOState((props as any).route.params.event);

    // Fetch the SVG content from the server
    useEffect(() => {
        fetch(`${SERVER_URL}/file/${event.map}`)
            .then((response) => response.text())
            .then((data) => {
                parseSvgWithEvents(data); // Parse and modify the SVG
            })
            .catch((error) => console.error('Error fetching SVG:', error));
    }, []);

    // Parse the SVG with xml2js and add event listeners to <rect> elements
    const parseSvgWithEvents = (svgString: string) => {
        setParsedSvg(svgString); // Set the modified SVG string with events
        setLoading(false);

        /*
        xml2js.parseString(
            svgString,
            { explicitArray: false },
            (err, result) => {
                if (err) {
                    console.error('Error parsing SVG:', err);
                    return;
                }

                // Traverse through the parsed SVG and add events to <rect> elements
                console.log('RESULT SVG', result.svg);
                //traverseAndAddEvents(result.svg);

                // Convert the modified SVG object back to a string
                const builder = new xml2js.Builder();
                const modifiedSvgString = builder.buildObject(result);
                setParsedSvg(modifiedSvgString); // Set the modified SVG string with events
                setLoading(false);
            },
        );*/
    };

    // Traverse the parsed SVG object and add onClick events to <rect> elements
    const traverseAndAddEvents = (element: any, parentG = false) => {
        if (!element) return;

        // If the element is a <rect>, add an onclick handler as a string attribute
        if (element.$ && element.$.id && Array.isArray(element.g)) {
            boxList[element.$.id] = element;
            for (const gCurr of element.g) {
                if (gCurr.rect) {
                    try {
                        gCurr.$[
                            'onclick'
                        ] = `window.postMessage(JSON.stringify({value: ${JSON.stringify(
                            element,
                            null,
                            4,
                        )}}));`;
                    } catch {}
                }

                /*if (gCurr.rect) {
                    try {
                        gCurr.$[
                            'onclick'
                        ] = `window.ReactNativeWebView.postMessage(JSON.stringify({value: ${JSON.stringify(
                            element,
                            null,
                            4,
                        )}}));`;
                    } catch {}
                }*/
            }
            /*
            if (element.g.$ && element.g.$.id) {
                boxList[element.g.$.id] = element;

                console.log('boxList', element);

                if (Array.isArray(element.g.rect)) {
                    element.g.rect.forEach((rect: any, index: number) => {
                        if (rect.$) {
                            console.log('RECT', rect);
                            rect.$[
                                'onclick'
                            ] = `window.ReactNativeWebView.postMessage(JSON.stringify({value: ${JSON.stringify(
                                element,
                                null,
                                4,
                            )}}));`;
                        }
                    });
                } else if (element.g.rect) {
                    if (element.g.rect.$) {
                        element.g.rect.$[
                            'onclick'
                        ] = `window.ReactNativeWebView.postMessage(JSON.stringify({value: ${JSON.stringify(
                            element,
                            null,
                            4,
                        )}}));`;
                    }
                }
            }*/
        }

        if (element.text) {
            if (Array.isArray(element.text)) {
                element.text.forEach((text: any, index: number) => {
                    try {
                        text.$[
                            'onclick'
                        ] = `window.postMessage(JSON.stringify({type: "text",value: "${text._}"
                    }));`;
                    } catch {}
                });
            } else {
                console.log(element.text._, element.text);
                if (
                    element.text &&
                    element.text.tspan &&
                    (element.text._ as string).includes('ESPACE')
                ) {
                    const split = (element.text._ as string).split('ESPACE');
                    console.log(split);

                    element.text._ = 'ESPACE';
                    element.text.tspan._ = element.text.tspan._ + split[1];
                }

                try {
                    element.text.$[
                        'onclick'
                    ] = `window.postMessage(JSON.stringify({type: "text",value: "${element.text._}"
                    }));`;
                } catch {}
            }
        }

        // Recursively process child elements if they exist
        Object.keys(element).forEach((key) => {
            if (typeof element[key] === 'object') {
                traverseAndAddEvents(element[key], key === 'g');
            }
        });
    };

    window.addEventListener('message', async (event) => {
        try {
            const data = JSON.parse(event.data);

            if (data.type && data.type === 'stand') {
                console.log(data);

                await getStand(data.hall, data.number);
            } else {
                onMessage(data);
            }
        } catch (error) {
            console.error('Error parsing message:', error);
        }
    });

    let scale = 1;
    let panX = 0;
    let panY = 0;
    let lastTouchDistance = 0;

    const containerRef = useRef(null);

    useEffect(() => {
        if (loading === false) {
            const svg = containerRef.current.querySelector('svg');
            if (svg) {
                svg.addEventListener('click', () => {
                    console.log('SVG clicked!');
                });

                // Apply styles to the SVG element

                svg.style.width = '100%';
                svg.style.height = '100%';

                svg.id = 'svg';

                setTimeout(() => {
                    const element = document.getElementById('svg');
                    // Panzoom is installed via cdn in the HTML template

                    const panzoom = Panzoom(element, {
                        maxScale: 40,
                        step: 0.75,
                    });
                    element.addEventListener('wheel', panzoom.zoomWithWheel);
                }, 200);
            }
        }
    }, [loading]);

    // HTML Template to embed the modified SVG and add zoom/pan functionality
    const htmlContent = `
            ${parsedSvg} 
    `;

    const standList = useJTOState(new JTOList(Stand));

    const getStand = async (hall: string, number: string) => {
        //(document.body.style as any).zoom = '100%';
        // Re-enable after a short delay

        const res = await get('/event/stand', {
            stand_name: number,
            hall_name: HALL_DICT[hall] ?? '',
            event_id: event.getJTOIdentifier(),
        });

        if (HTTPUtils.isSuccess(res)) {
            standList.reset();
            applyResult(HTTPUtils.getResult(res), standList, true);

            props.navigation.navigate('ExposantModalList', {
                event,
                standList,
            });
        }
    };

    const parseTransform = (transform: any) => {
        const match = /translate\(([^,]+),([^\)]+)\)/.exec(transform);
        if (match) {
            return { x: parseFloat(match[1]), y: parseFloat(match[2]) };
        }
        return { x: 0, y: 0 };
    };

    const { t } = useTranslation();

    // Handle message from the WebView in React Native
    const onMessage = (data: any) => {
        const item = data.value;

        if (item && item.$ && item.$.id) {
            const parent = boxList[item.$.id];

            if (parent && parent.$) {
                const boxTransform = parent.$.transform;

                const base = parseTransform(boxTransform);

                if (Array.isArray(parent.g)) {
                    for (const g of parent.g) {
                        if (g.rect && g.rect.$) {
                            //get the number value of g.rect.$.x, g.rect.$.y, g.rect.$.width, g.rect.$.height
                            const x = parseFloat(g.rect.$.x);
                            const y = parseFloat(g.rect.$.y);
                            const height = parseFloat(g.rect.$.height);
                            const width = parseFloat(g.rect.$.width);

                            const globalX = base.x + x;
                            const globalY = base.y + y;

                            const bottomLeft = {
                                x: globalX,
                                y: globalY,
                            };

                            const topRight = {
                                x: globalX + width,
                                y: globalY + height,
                            };
                        }
                    }
                }
            }
        }
    };

    const textInput = useRef(null);
    useEffect(() => {
        setTimeout(() => {
            if (textInput.current) {
                textInput.current.click();
            }
        }, 400); // Reduced from 1000 to a shorter delay to test
    }, []);

    return (
        <View
            style={[
                styles.container,
                {
                    backgroundColor: getColor('background'),
                },
            ]}
        >
            <Header
                modal={true}
                title={t('map')}
                line={1}
                logo={User._instance.getEvent()?.logo.get() ?? ''}
                backButton={true}
                navigation={props.navigation}
                after={
                    <View
                        style={{
                            height: 10,
                            flex: 1,
                        }}
                    ></View>
                }
            >
                {loading ? (
                    <View
                        style={{
                            flex: 1,

                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <GeSpinner color={getColor('primary')} />
                    </View>
                ) : (
                    /*<div
                            ref={containerRef}
                            style={{
                                width: '100%',
                                height: '100%',
                                overflow: 'scroll', // Enable scroll on both axes
                                position: 'relative', // Ensure proper positioning
                                padding: '0', // No padding to interfere with scrolling
                            }}
                            onClick={() => {}}
                        >*/
                    <div
                        ref={containerRef}
                        style={{
                            height: '100%',
                            width: '100%',
                            margin: '0 auto', // Centering effect without restricting scroll
                            position: 'relative',
                        }}
                        dangerouslySetInnerHTML={{
                            __html: htmlContent,
                        }}
                    />
                    /*</div>*/
                )}
            </Header>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    webView: {
        width: width,
        height: height,
    },
});
